import type { Page, Store } from '@subaio/utils'

export enum ContainerStatus {
	Initializing = 'Initializing',
	Loading = 'Loading',
	Running = 'Running',
	Errored = 'Errored',
}

export type ContainerState<T extends Record<string, any> = Record<string, unknown>> = {
	page: Page
	status: ContainerStatus

	data: T
}

export type ContainerStore = Store<ContainerState>
